import "./Button.scss";

const Button = ({
  caption = "",
  onClick = null,
  type = "primary-1",
  shape = "round",
  style = {},
  children,
  disabled = false,
}) => {
  const handleButtonClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onClick) {
      onClick();
    }
  };

  return (
    <button
      className={`${type} ${shape} buttonContainer`}
      onClick={handleButtonClick}
      style={style}
      disabled={disabled}
    >
      {children}
      {caption.toUpperCase()}
    </button>
  );
};

export default Button;
